import { FC } from 'react'
import { IconPaths, TipoReceitaSncr } from '_metronic/helpers'
import { Selo } from '../../core/montagem/itens'
import styles from '../../Prescricao.module.scss'
import { Icone } from './Icone'
import { useRotulos } from './useRotulos'

const CLASSE_SELO: Record<Selo, string> = {
  controle: styles.seloControle,
  retencao: styles.seloRetencao,
  nra: styles.seloNotificacao,
  nrb: styles.seloNotificacao,
  nrb2: styles.seloNotificacao,
  nrr: styles.seloNotificacao,
  lme: styles.seloLme,
  apac: styles.seloApac,
}

/**
 * Escudo para controle especial e notificações, relógio para retenção; LME e APAC já se
 * distinguem pelo próprio texto.
 */
const ICONE_SELO: Partial<Record<Selo, IconPaths>> = {
  controle: IconPaths.Escudo,
  retencao: IconPaths.Relogio,
  nra: IconPaths.Escudo,
  nrb: IconPaths.Escudo,
  nrb2: IconPaths.Escudo,
  nrr: IconPaths.Escudo,
}

export const SelosDoItem: FC<{ selos: Selo[] }> = ({ selos }) => {
  const { rotuloSelo } = useRotulos()
  if (selos.length === 0) return null
  return (
    <span className='d-flex flex-wrap gap-1'>
      {selos.map((selo) => (
        <span key={selo} className={`${styles.selo} ${CLASSE_SELO[selo]}`}>
          {ICONE_SELO[selo] && <Icone icone={ICONE_SELO[selo] as IconPaths} />}
          {rotuloSelo(selo)}
        </span>
      ))}
    </span>
  )
}

/** Validade em dias ("Validade 10 dias") ou já em data ("Válida até 01/11/2026"). */
export const SeloValidade: FC<{ texto: string }> = ({ texto }) => (
  <span className={`${styles.selo} ${styles.seloNeutro}`}>
    <Icone icone={IconPaths.Relogio} />
    {texto}
  </span>
)

export const SeloSncr: FC<{ tipo: TipoReceitaSncr; numero?: string | null }> = ({
  tipo,
  numero,
}) => {
  const { t } = useRotulos()
  return (
    <span
      className={`${styles.selo} ${
        tipo === TipoReceitaSncr.RCE ? styles.seloControle : styles.seloRetencao
      }`}
    >
      <span aria-hidden>#</span>
      {numero ? `${tipo} ${numero}` : t('prescricao.sncr.selo', { tipo })}
    </span>
  )
}
